var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type)?_c('ui-icon',{staticClass:"mm-dialog-type-icon",attrs:{"name":_vm.type,"fill":_vm.iconColor,"size":"48px"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }